import { useState } from 'react'
import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@store/authStore'

const NAV_ITEMS = [
  { to: '/app/dashboard',    icon: '📊', label: 'Bảng điều khiển' },
  { to: '/app/sites',        icon: '🏢', label: 'Địa điểm' },
  { to: '/app/alerts',       icon: '🔔', label: 'Cảnh báo' },
  { to: '/app/action-plans', icon: '📋', label: 'Hành động' },
  { to: '/app/reports',      icon: '📄', label: 'Báo cáo' },
]

export default function AppLayout() {
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()
  const [expanded, setExpanded] = useState(false)

  const handleLogout = () => { logout(); navigate('/login') }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

      {/* ── Header ── */}
      <header style={{
        height: 52, background: 'white', borderBottom: '1px solid #e2e8f0',
        display: 'flex', alignItems: 'center', padding: '0 20px',
        gap: 18, flexShrink: 0, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', zIndex: 200,
      }}>
        {/* Hamburger — toggles sidebar expand */}
        <button onClick={() => setExpanded(!expanded)} style={{
          background: 'none', border: 'none', cursor: 'pointer',
          fontSize: 18, color: '#64748b', padding: 4, borderRadius: 6,
          transition: 'background .15s',
        }}
          onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
          onMouseLeave={e => e.currentTarget.style.background = 'none'}
        >☰</button>

        <span style={{ fontWeight: 800, fontSize: 15, letterSpacing: 0.5, color: '#0f172a' }}>
          ANALYSIS
        </span>

        <div style={{ flex: 1 }} />

        {/* User avatar */}
        <div style={{
          width: 34, height: 34, borderRadius: '50%', background: '#f59e0b',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: 700, color: 'white', fontSize: 12, cursor: 'pointer',
        }} onClick={handleLogout} title={`${user?.name || ''} — Logout`}>
          {user?.initials || 'AJ'}
        </div>
      </header>

      {/* ── Body ── */}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>

        {/* ── Unified Sidebar ── */}
        <nav style={{
          width: expanded ? 220 : 56,
          minWidth: expanded ? 220 : 56,
          background: 'white',
          borderRight: '1px solid #e2e8f0',
          display: 'flex',
          flexDirection: 'column',
          paddingTop: 8,
          flexShrink: 0,
          transition: 'width .25s ease, min-width .25s ease',
          overflow: 'hidden',
          boxShadow: expanded ? '2px 0 8px rgba(0,0,0,0.06)' : 'none',
        }}>

          {NAV_ITEMS.map(item => (
            <NavLink key={item.to} to={item.to} title={!expanded ? item.label : ''} style={({ isActive }) => ({
              display: 'flex', alignItems: 'center',
              gap: 12,
              margin: '2px 8px',
              padding: '0 8px',
              height: 40,
              borderRadius: 8,
              textDecoration: 'none',
              background: isActive ? '#dbeafe' : 'transparent',
              color: isActive ? '#2563eb' : '#64748b',
              transition: 'background .15s, color .15s',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            })}
              onMouseEnter={e => { if (!e.currentTarget.style.background.includes('dbeafe')) e.currentTarget.style.background = '#f8fafc' }}
              onMouseLeave={e => { if (!e.currentTarget.style.background.includes('dbeafe')) e.currentTarget.style.background = 'transparent' }}
            >
              <span style={{ fontSize: 18, flexShrink: 0, width: 24, textAlign: 'center' }}>{item.icon}</span>
              <span style={{
                fontSize: 13, fontWeight: 500,
                opacity: expanded ? 1 : 0,
                transition: 'opacity .2s',
              }}>{item.label}</span>
            </NavLink>
          ))}

          {/* Spacer */}
          <div style={{ flex: 1 }} />

          {/* Collapse/Expand button at bottom */}
          <button onClick={() => setExpanded(!expanded)} style={{
            display: 'flex', alignItems: 'center', gap: 12,
            margin: '4px 8px 12px',
            padding: '0 8px',
            height: 40,
            borderRadius: 8,
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#94a3b8', whiteSpace: 'nowrap', overflow: 'hidden',
            transition: 'background .15s',
          }}
            onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
            onMouseLeave={e => e.currentTarget.style.background = 'none'}
          >
            <span style={{ fontSize: 16, flexShrink: 0, width: 24, textAlign: 'center', transition: 'transform .25s', transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              ▶
            </span>
            <span style={{ fontSize: 12, opacity: expanded ? 1 : 0, transition: 'opacity .2s' }}>
              Collapse
            </span>
          </button>
        </nav>

        {/* ── Page Content ── */}
        <main style={{ flex: 1, overflow: 'auto' }}>
          <Outlet />
        </main>

      </div>
    </div>
  )
}
